import {
  PaywayId,
  ShippingTypeId,
  WholesaleStatus,
  InvoiceTypeId,
} from "./enums";

// ─── Variantes de producto ────────────────────────────────────────────────────

/** Tipo de agrupación de variantes. "size" = Talle, "color" = Color. Extensible. */
export type VariantGroupType = "size" | "color" | string;

export interface VariantOption {
  /** product_id del producto que representa esta opción de variante */
  id: number;
  /** Etiqueta visible: "S", "Negro", "128GB" */
  label: string;
  /** true si no hay stock */
  disabled: boolean;
}

export interface VariantGroup {
  /** Tipo del grupo: "size", "color", u otro custom */
  groupType: VariantGroupType;
  /** Label que se muestra encima del picker: "Talle", "Color", etc. */
  label: string;
  options: VariantOption[];
}

// ─── Nuevo sistema de variantes (desde API) ───────────────────────────────────

export interface VariantOptionData {
  type_id: number;
  label: string;
  product_ids: number[];
}

export interface VariantGroupData {
  id: number;
  name: string;
  options: VariantOptionData[];
}

export interface VariantsData {
  groups: VariantGroupData[];
  combinations: Record<string, Record<string, number>>;
}

export const ADD_SWAP = "ADD_SWAP";
export interface LoadingOrderAction {
  type: typeof LOADING_ORDER;
}
export const LOADING_ORDER = "LOADING_ORDER";
export const FETCH_SIMILAR_PRODUCTS = "FETCH_SIMILAR_PRODUCTS";
export const FETCH_SHOP = "FETCH_SHOP";
export const LOADING_SHOP = "LOADING_SHOP";
export const FETCH_SHOP_PRODUCT = "FETCH_SHOP_PRODUCT";
export const FETCH_SHOP_TYPE = "FETCH_SHOP_TYPE";
export const FETCH_TRACKING_SALE = "FETCH_TRACKING_SALE";
export const LOADING_PRODUCT_BUTTONS = "LOADING_PRODUCT_BUTTONS";
export const FETCH_MY_ORDERS = "FETCH_MY_ORDERS";
export const SET_LOGIN = "SET_LOGIN";
export const RESET_SHOP = "RESET_SHOP";
export const FETCH_MENU = "FETCH_MENU";

export const ADD_CART = "ADD_CART";
export const FETCH_CART = "FETCH_CART";
export const DELETE_ITEM_CART = "DELETE_ITEM_CART";
export const UPDATE_CART = "UPDATE_CART";
export const FETCH_CLIENT = "FETCH_CLIENT";
export const CHECKOUT_CART = "CHECKOUT_CART";
export const LOADING_CART = "LOADING_CART";
export const EXTEND_CART_SESSION = "EXTEND_CART_SESSION";
export const RESET_ALERT_MESSAGE_CART = "RESET_ALERT_MESSAGE_CART";
export const FETCH_SHIPPING_COST = "FETCH_SHIPPING_COST";
export const RESET_SHIPPING_COST = "RESET_SHIPPING_COST";
export const RESET_CLIENT = "RESET_CLIENT";
export const SET_RESELLER_COUPON = "SET_RESELLER_COUPON";

export interface Product {
  id: number;
  code: number;
  cost: string | number;
  name: string;
  path: string;
  price: string | number;
  price_wholesale: string | number;
  price_regular: string | number;
  description: string;
  purchasable: number;
  salable: number;
  weight: string;
  user_id?: number;
  discontinued_at?: string | null;
  deleted_at?: string | null;
  created_at?: string;
  updated_at?: string;
  types: Type[];
  cantCart?: number;
  rowId?: string;
  stock?: number;
}

export interface Type {
  id: number;
  name: string;
  path: string | null;
  user_id?: number;
  deleted_at?: string | null;
  created_at?: string;
  updated_at?: string;
  pivot: {
    product_id: number;
    type_id: number;
  };
}

export interface MenuProductType {
  id: number;
  parent_id: number | null;
  show: number;
  name: string;
  path: string | null;
  user_id: number;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
  children: MenuProductType[];
}

export interface HomeCategory {
  id_type: number;
  title: string;
  products: Product[];
}

export interface Cart {
  id: number;
  name: string;
  options: {
    img: string;
    shoppingCartId: number;
    updated_at: string;
    product: Product;
  };
  price: number;
  qty: number;
  rowId: string;
}

//Shop

export interface ShopState {
  home_categories: HomeCategory[];
  products: any[];
  product: any;
  typesSizes: any;
  variants: any;
  pathImages: any;
  isDisabledSite: boolean;
  isLoading: boolean;
  textPages: any;
  isLoadingProductButtons: boolean;
  myOrders: any[];
  isLogued: boolean;
  lastPage: boolean;
  menuProducts: MenuProductType[];
}

interface FetchShopAction {
  type: typeof FETCH_SHOP;
  payload: {
    home_categories: HomeCategory[];
    isDisabledSite: boolean;
  };
}

interface LoadingShopAction {
  type: typeof LOADING_SHOP;
}

interface ResetShopAction {
  type: typeof RESET_SHOP;
}

interface LoadingProductButtonsAction {
  type: typeof LOADING_PRODUCT_BUTTONS;
}

interface FetchShopProductAction {
  type: typeof FETCH_SHOP_PRODUCT;
  payload: { product: Product; pathImages: string[]; typesSizes: Type[]; variants: VariantsData };
}

interface FetchShopTypeAction {
  type: typeof FETCH_SHOP_TYPE;
  payload: {
    page: number;
    products: Product[];
    last_page: boolean;
  };
}

interface FetchTrackingSale {
  type: typeof FETCH_TRACKING_SALE;
  payload: any;
}

interface FetchMenuAction {
  type: typeof FETCH_MENU;
  payload: {
    products: MenuProductType[];
    headerMessage: string;
    termsAndConditions: string;
    textHowtobuy: string;
    textHowtopay: string;
    textSends: string;
    textChanges: string;
  };
}

//Cart

export interface CartState {
  cart: Cart[] | [];
  totalCart: number;
  itemsCart: number;
  minimumCart: number;
  minimumPurchaseAmount: number;
  alertMessage: string | null;
  payways: { id: number; name: string }[] | null;
  client: {} | null;
  addressPickup: string | null;
  incrementSale: number;
  messageFinish: string | null;
  frequentUserCoupon: string | null;
  isLoading: boolean;
  provinces: any[];
  shippingCost: number;
  discountCashShop: number;
  resellerPercentageDiscount: number;
  resellerCoupon: string;
  resellerMinAmountDiscount: number;
  appliedResellerCoupon: string | null;
}

interface FetchCart {
  cart: Cart[];
  totalCart: number;
  itemsCart: number;
  minimumCart: number;
  minimumPurchaseAmount: number;
  frequentUserCoupon: string | null;
  discountCashShop: number | null;
  resellerPercentageDiscount: number;
  resellerCoupon: string;
  resellerMinAmountDiscount: number;
}

export interface CheckoutData {
  /** ID del shop en el backend (multi-tenant, ex user_id) */
  shop_id: number;
  post: string;
  wholesale: WholesaleStatus;
  invoice_type_id: InvoiceTypeId;
  client_id: number;
  cell_phone: string;
  name: string;
  document_number: string;
  email: string;
  last_name: string;
  address: string;
  city: string;
  postal_code: string;
  province: number;
  local_pickup: ShippingTypeId;
  payway_id: PaywayId;
  increase1: number;
  discount1: number;
  totalCart: number;
  subTotalCart: number;
  shippingCost: number;
  isResellerDiscount: boolean;
}

export interface FetchClientData {
  cell_phone: string;
  client_id: string | null;
}

interface FetchCartAction {
  type: typeof FETCH_CART;
  payload: FetchCart;
}

interface AddCartAction {
  type: typeof ADD_CART;
  payload: FetchCart & { alertMessage: string };
}

interface DeleteCartAction {
  type: typeof DELETE_ITEM_CART;
  payload: FetchCart;
}

interface UpdateCartAction {
  type: typeof UPDATE_CART;
  payload: FetchCart & { alertMessage: string };
}

interface FetchClientCartAction {
  type: typeof FETCH_CLIENT;
  payload: any;
}

interface FetchShippingCostAction {
  type: typeof FETCH_SHIPPING_COST;
  payload: any;
}

interface ResetShippingCostAction {
  type: typeof RESET_SHIPPING_COST;
}

interface CheckOutCartAction {
  type: typeof CHECKOUT_CART;
  payload: any;
}

interface LoadingCartAction {
  type: typeof LOADING_CART;
}

interface ExtendSessionCartAction {
  type: typeof EXTEND_CART_SESSION;
}

interface ResetAlertMessageCart {
  type: typeof RESET_ALERT_MESSAGE_CART;
}

interface ResetClientCart {
  type: typeof RESET_CLIENT;
}

interface SetResellerCouponAction {
  type: typeof SET_RESELLER_COUPON;
  payload: string | null;
}

interface FetchMyOrdersAction {
  type: typeof FETCH_MY_ORDERS;
  payload: any;
}

interface SetLoginAction {
  type: typeof SET_LOGIN;
  payload: any;
}

interface FetchSimilarProductsAction {
  type: typeof FETCH_SIMILAR_PRODUCTS;
  payload: {
    productName: string;
    similarProducts: any[];
    loading?: boolean;
  };
}

export type ShopActionTypes =
  | FetchShopAction
  | LoadingShopAction
  | FetchShopProductAction
  | FetchShopTypeAction
  | FetchTrackingSale
  | LoadingProductButtonsAction
  | FetchMyOrdersAction
  | SetLoginAction
  | ResetShopAction
  | FetchSimilarProductsAction
  | LoadingOrderAction
  | FetchMenuAction;

export type CartActionTypes =
  | FetchCartAction
  | AddCartAction
  | DeleteCartAction
  | UpdateCartAction
  | FetchClientCartAction
  | CheckOutCartAction
  | LoadingCartAction
  | ExtendSessionCartAction
  | ResetAlertMessageCart
  | FetchShippingCostAction
  | ResetShippingCostAction
  | ResetClientCart
  | SetResellerCouponAction;
